module.exports = __webpack_public_path__ + "static/media/hurray.f3357449.svg";